import React, { FunctionComponent } from 'react'
import PuxIcon from 'Shared/components/PuxIcon/PuxIcon'
import PuxWysiwyg from 'Shared/components/PuxWysiwyg/PuxWysiwyg'

import PlansTableInfoIcon from './PlansTableInfoIcon'
import { getFeatureInputHtml, isFeatureAvailable } from './pricingFormatters'
import { PricingPlan } from './pricingPlans'
import { PricingFeatureType } from './pricingTypes'
import { PuxAnchorLink } from 'Root/Shared/utils/PuxAnchorLink/PuxAnchorLink'
import { PuxButton } from 'Root/Shared/components'

interface PlansTableFeatureCellProps {
  feature: PricingFeatureType
  first?: boolean
  last?: boolean
  plan: PricingPlan
  mobile?: boolean
}

const PlansTableFeatureCell: FunctionComponent<PlansTableFeatureCellProps> = ({
  feature,
  first,
  last,
  plan,
  mobile,
}) => {
  const available = isFeatureAvailable(feature, plan.id)
  const text = getFeatureInputHtml(feature, plan.id)
  const title = feature.pricingFeatureTooltip || feature.displayText

  const render = (content) => {
    if (content.includes('+ Add-ons')) {
      return (
        <div className='PlansTable-cell-text'>
          <PuxButton 
            buttonLink={{
                      url: [`/`],
                      internal: [false],
                      text: [ 'Add-ons' ],
                    }}
            buttonOpenModalId='add-ons' 
            buttonType='underline' 
            buttonSize='large' 
            buttonIcon={'user-interface/c-add'} />
        </div>
      )
    } else {
      return (
        <div className='PlansTable-cell-text'>
          <PuxWysiwyg content={{ html: content }} headless={true} />
        </div>
      )
    }
  }

  return (
    <div
      className={`PlansTable-cell${
        available || text ? `` : ` PlansTable-cell--empty`
      }${plan.highlighted ? ` PlansTable-cell--highlighted` : ``}${
        first ? ` PlansTable-cell--first` : ``
      }${last ? ` PlansTable-cell--last` : ``}`}
    >
      <div className='PlansTable-cellContent'>
        {mobile ? (
          <>
            <span className='PlansTable-cell-mobile-label'>
              <span>{feature.displayText}</span>
            </span>
            <PlansTableInfoIcon title={title} />
          </>
          ) : null}
        {available ? (
          <span
            className='PlansTable-cell-icon PlansTable-cell-icon--check'
            aria-hidden='true'
          >
            <PuxIcon name='user-interface/check' size={16} decorative />
          </span>
        ) : null}
        {!available && text ? (
          render(text)
        ) : undefined}
        {!available && !text ? (
          <PuxIcon
            className='PlansTable-cell-icon PlansTable-cell-icon--empty'
            name='user-interface/e-delete'
            size={24}
            decorative
          />
        ) : null}
      </div>
    </div>
  )
}

export default PlansTableFeatureCell
